import { COLOR_WHITE } from 'constants/colors';
import styled from 'styled-components';
import { Descriptions } from 'UI';

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 1.5rem;
  background-color: ${COLOR_WHITE};
`;

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 1.5rem;
  background-color: ${COLOR_WHITE};
  gap: 1.5rem;
`;

export const OrderDescriptions = styled(Descriptions)`
  width: 100%;
`;

export const TableContainer = styled.div`
  width: 100%;
`;

export const TableHeader = styled.div`
  display: none;
`;

export const ClickableColumnWrapper = styled.div`
  cursor: pointer;
  display: flex;
  gap: 1rem;
`;
